import { makeStyles, CardContent, Grid, FormControl, InputLabel, Select, Card, Typography } from '@material-ui/core';
import React, { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { useHistory } from 'react-router';
import axios from 'axios';
import moment from 'moment';
import ActionTable from '../common/Table';
// import Layout from '../common/Layout';
import { CommonConfig } from '../../../config/common-config';
import SearchBox from '../../../components/table/SearchBox';
// import VisibilityIcon from '@material-ui/icons/Visibility';
// import GetAppIcon from '@material-ui/icons/GetApp';

const useStyles = makeStyles((theme) => ({
    root: {
        flexGrow: 1,
        marginTop: theme.spacing(6),
    },
    container: {
        marginBottom: theme.spacing(1),
    },
    paper: {
        marginBottom: theme.spacing(1),
    },
    noRecord: {
        display: 'flex',
        justifyContent: 'center',
        background: '#f6f6f6',
        margin: '16px',
        '& h1': {
            alignSelf: 'center',
            color: 'grey',
            fontFamily: 'Rubik',
            fontSize: '14px',
            fontWeight: '400',
        },
    },
}));

const AdminInvoiceView = (props) => {
    const [searchQuery, setSearchQuery] = useState('');
    const [rows, setRows] = useState([]);
    const [AllImcs, setAllImcs] = useState([]);
    const [selectedImc, setselectedImc] = useState([]);
    const tempToken = useSelector((state) => state.loginsuccessreducer.loggedInUserDetails.result);
    const userToken = tempToken && tempToken.data.token;
    const bearerToken = `Bearer ${userToken}`;
    const axiosConfig = {
        headers: {
            'Content-Type': 'application/json;charset=UTF-8',
            Authorization: bearerToken,
        },
    };
    const [pageDetails, setPageDetails] = useState('');
    const [previousButton, setpreviousButton] = useState(false);
    const [nextButton, setnextButton] = useState(false);
    const [loading, setLoading] = useState(false);
    const [page, setPage] = useState(0);
    const [searchData, setSearchData] = useState([]);
    const [noRecordCount, setNoRecordCount] = useState(false);

    function formatDate(props) {
        return props.map((element) => {
            // element.invoiceDate = moment(element.invoiceDate).format('DD-MM-YYYY');
            // element.dateModified = moment(element.dateModified).format('DD-MM-YYYY');
            // const tempStartDate = element.requestInvoicedate;
            const tempEndDate = element.dateModified;
            const tempRequestInvoicedate = element.requestInvoicedate;
            // const pattern = /(\d{2})\/(\d{2})\/(\d{4})/;
            // const formatStartDate = new Date(tempStartDate.replace(pattern, '$3-$2-$1'));
            // const formatEndDate = new Date(tempEndDate.replace(pattern, '$3-$2-$1'));
            // element.requestInvoicedate = moment(formatStartDate).format('DD-MM-YYYY');
            // element.dateModified = moment(formatEndDate).format('DD-MM-YYYY');
            element.dateModified = tempEndDate.split(' ', 1);
            element.requestInvoicedate = tempRequestInvoicedate.split(' ', 1);
        });
    }
    const headcells = [
        { id: 'buyerId', label: 'Client ID' },
        { id: 'buyerFirstName', label: 'Client Name' },
        { id: 'employeeId', label: 'Employee Id' },
        { id: 'employeeName', label: 'Employee Name' },
        { id: 'invoiceNumber', label: 'Invoice ID' },
        { id: 'requestInvoicedate', label: 'Request Invoice Date' },
        { id: 'totalAmount', label: 'Invoice Amount' },
        { id: 'dateModified', label: 'Email sent Date' },
        { id: 'isPaid', label: 'Status' },
    ];
    const userDetails = useSelector((state) => state.loginsuccessreducer.loggedInUserDetails);
    //const usertype = userDetails.result && userDetails.result.data.userType;
    const userTeam = userDetails.result && userDetails.result.data.features[0].team;
    const userDomain = userDetails.result && userDetails.result.config.data;

    const handleCount = (val) => {
        if (val === 'prev') {
            if (pageDetails.first !== true) {
                setPage((page) => page - 1);
            }
        }

        if (val === 'next') {
            if (pageDetails.last !== true) {
                setPage((page) => page + 1);
            }
        }
    };

    const setImc = (e) => {
        //console.log("E target" ,e)
        let imc = '';
        if (e.target) {
            imc = e.target.value;
        } else {
            imc = e;
        }
        setselectedImc(imc);
        setLoading(true);
        setpreviousButton(true);
        setnextButton(true);

        if (searchQuery && searchQuery.length > 2) {
            getSearchValue(searchQuery);
            setNoRecordCount(false);
            return true;
        } else {
            setSearchData([]);
            getInvoiceValue(imc);
            setNoRecordCount(true);
            return false;
        }
    };

    // At the time of Component mounts
    const history = useHistory();
    useEffect(() => {
        axios
            .get(`${CommonConfig.dev.baseUrl}/api/auth/s-int-clients`, axiosConfig)
            .then((response) => {
                console.log('Response Imc', response);
                setAllImcs(response.data.content);
                setImc(response.data.content[0].dbName);
            })
            .catch((error) => {
                //console.log(error);
            });
        if (userTeam != 'Itec Team') {
            if (userDomain) {
                let JsonUserDomain = JSON.parse(userDomain);
                ////console.log("userDomain",JsonUserDomain.tennantName);
                setImc(JsonUserDomain.tennantName);
            }
        }
    }, [userToken, page]);

    const allImcsOptions = (vv) => {
        const OptionList = vv.map((data) => <option value={data.dbName}>{data.dbName}</option>);
        return OptionList;
    };

    // handle search item
    const handleSearchQuery = (data) => {
        setSearchQuery(data);
        console.log('data', data);
        if (data && data.length > 2) {
            setPage(0);
            setNoRecordCount(false);
            getSearchValue(data);
            return true;
        } else {
            setNoRecordCount(true);
        }
        if (!data) {
            setSearchData([]);
            setPage(0);
            getInvoiceValue(selectedImc);
        }
    };

    //append comma
    function numberWithCommas(tempList) {
        return tempList.map((ele) => {
            console.log('ele', ele);
            ele.totalAmount = ele.totalAmount.toString();
            ele.totalAmount = new Intl.NumberFormat('en-IN').format(parseFloat(ele.totalAmount.replace(/,/g, '')));
        });
    }

    const getInvoiceValue = (imc) => {
        axios
            .get(`${CommonConfig.dev.baseUrl}/api/auth/admininvoices/${imc}?page=${page}&size=10&sort=id,desc`, axiosConfig)
            .then((res) => {
                console.log('ResponseInvoice', res);
                formatDate(res.data.content);
                numberWithCommas(res.data.content);
                setRows(res.data.content);
                setPageDetails(res.data);
                setLoading(false);
                if (res.data.first) {
                    setpreviousButton(true);
                    setnextButton(false);
                } else if (res.data.last) {
                    setpreviousButton(false);
                    setnextButton(true);
                } else {
                    setpreviousButton(false);
                    setnextButton(false);
                }
            })
            .catch((error) => { });
    };

    const getSearchValue = (data) => {
        console.log('data', data);

        axios
            .get(`${CommonConfig.dev.baseUrl}/api/auth/admininvoices/${selectedImc}?search=${data}&page=${page}&size=10&sort=dateModified,desc`, axiosConfig)
            .then((res) => {
                // console.log('responseresponse11', res);
                if (res.data) {
                    if (res.data.content.length === 0) {
                        setRows([]);
                    }
                    formatDate(res.data.content);
                    setSearchData(res.data.content);
                    setPageDetails(res.data);
                    setLoading(false);
                    if (res.data.first) {
                        setpreviousButton(true);
                        setnextButton(false);
                    } else if (res.data.last) {
                        setpreviousButton(false);
                        setnextButton(true);
                    } else {
                        setpreviousButton(false);
                        setnextButton(false);
                    }
                }
            })
            .catch((error) => { });
    };

    const clearField = () => {
        setSearchQuery('');
        setSearchData([]);
        setPage(0);
        getInvoiceValue(selectedImc);
        // console.log('clearclear');
    };

    const classes = useStyles();

    // filtered row based on search

    // const filteredRow = searchQuery
    //     ? rows.filter((row) => {
    //         const query = searchQuery.toLowerCase().trim();
    //         return headcells
    //             .map((col) => col.id)
    //             .some((key) => {
    //                 //return row[key].toString().toLowerCase().includes(query);
    //                 if (row[key]) {
    //                     //   ////console.log('searchRow[key.id]',searchRow[key.id])
    //                     //   ////console.log('toString().toLowerCase()',searchRow[key.id].toString().toLowerCase())
    //                     return row[key].toString().toLowerCase().includes(query);
    //                 } else {
    //                     return false;
    //                 }
    //             });
    //     })
    //     : rows;

    const filteredRow = searchData && searchData.length ? searchData : rows;

    return (
        <div className={classes.root}>
            {userTeam === 'Itec Team' ? (
                <CardContent>
                    <Grid spacing={3} className="main-container">
                        <Grid item xs={12} sm={12} style={{ paddingLeft: '0' }}>
                            <FormControl fullWidth>
                                <InputLabel className="lbl" htmlFor="selectimc" shrink>
                                    Select IMC
                                </InputLabel>
                                <Select native className="bottom" name="intclientName" onChange={setImc} value={selectedImc}>
                                    <option value="" selected disabled hidden>
                                        Select IMC
                                    </option>
                                    {allImcsOptions(AllImcs)}
                                </Select>
                            </FormControl>
                        </Grid>
                    </Grid>
                </CardContent>
            ) : (
                    ''
                )}
            <Card className="custom-table">
                <CardContent className="card-title-display">
                    <Grid item xs={12} sm={8}>
                        <Typography className="card-title">View Invoice</Typography>
                    </Grid>
                    <Grid item xs={12} sm={6} className="card-search">
                        <div className="search-field">
                            <SearchBox
                                searchQuery={searchQuery}
                                onChange={handleSearchQuery}
                                clearField={clearField}
                                placeholder="Search..."
                            />
                        </div>
                    </Grid>
                </CardContent>
                <CardContent className="card-table-display">
                    {rows && filteredRow.length > 0 ? (
                        <>
                            <ActionTable
                                handleCount={handleCount}
                                headcells={headcells}
                                rows={filteredRow}
                                action
                                post="admin"
                                mode="view"
                                pageDetails={pageDetails}
                                prvnxtbt={{ prvBt: previousButton, nxtBt: nextButton }}
                                loading={loading}
                            />
                        </>
                    ) : (
                            <div className={classes.noRecord}>
                                <h1>No records to display</h1>
                            </div>
                        )}
                </CardContent>
            </Card>
            {/* <div className="itec-textboxes">
                Select IMC{' '}
                <select className="intclientName intSelect" name="intclientName" onChange={setImc} value={selectedImc}>
                    <option value="" selected disabled hidden>Select IMC</option>
                    {allImcsOptions(AllImcs)}
                </select>
            </div>
            <Layout title="View Generated Invoice" searchQuery={searchQuery} onChange={handleSearchQuery} className={classes}>
                {filteredRow.length === 0 && <span style={{ fontSize: '14px', fontWeight: '700' }}>No records found to display!</span>}
                <ActionTable headcells={headcells} rows={filteredRow} action post="admin" mode="view" />
            </Layout> */}
        </div>
    );
};

export default AdminInvoiceView;
